import { render, staticRenderFns } from "./ssu.vue?vue&type=template&id=89e35dce"
import script from "./ssu.vue?vue&type=script&lang=js"
export * from "./ssu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports